import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import styles from './fade-in.module.scss';

const FadeIn = (props) => {
  const { children, isVisible, key, timeout, ...rest } = props;

  return (
    <CSSTransition
      {...rest}
      in={isVisible}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        enterDone: styles.enterDone,
        exit: styles.exit,
        exitActive: styles.exitActive,
        exitDone: styles.exitDone,
      }}
      timeout={timeout}
      key={key}
      style={{ transitionDuration: `${timeout}ms` }}
    >
      {React.Children.only(children)}
    </CSSTransition>
  );
};

FadeIn.defaultProps = {
  isVisible: false,
  timeout: 1000,
};

FadeIn.propTypes = {
  children: PropTypes.any.isRequired,
  isVisible: PropTypes.bool,
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  timeout: PropTypes.number,
};

export default FadeIn;
